export enum StartingType {
    DOL,
    YD
}
